import React, { useEffect, useState, useMemo, useCallback, memo } from "react";
import "./Css/Download_pdf.css";
import { Modal } from "react-bootstrap";
import { getdetailsById } from "../../../Services/wps_details-service";
import { getbyprojectno } from "../../../Services/wps_groove-services";
import { jsPDF } from "jspdf";
import Groove_pdf_page1 from "./Pages/Groove_pdf_page1";
import Groove_pdf_page2 from "./Pages/Groove_pdf_page2";
import Tubesheet_Pdf_Page2 from "./Pages/Tubesheet_pdf_page2";
import { getPresignedURL } from "../../../Services/Welder-services";
import BarLoader from "react-spinners/BarLoader";
import TubeToTubesheet_pdf_page1 from "./Pages/TubeToTubesheet_pdf_page1";
import Jspdf_font from "../../../Assests/font/jsPdf_font";
import { getActiveProcess } from "../../../Services/weldingprocess-services";


const FOLDERS = {
  SIGNATURES: "wld_signatures",
  WPS: "WPS_Groove"
};

const PDF_TIMEOUT = 9000;
const PDF_MARGIN = [-25, 10, 10, 10];

const Pdf_Download = memo((props) => {
  const [loading, setLoading] = useState(true);
  const [previewUrls, setPreviewUrls] = useState({ url1: null, url2: null, url3: null });
  const [pdf, setpdf] = useState([]);
  const [signatures, setSignatures] = useState({ user: "", approved: "" });

  const fetchbyid = useCallback(async (IddetailPK, IddetailSK) => {
    try {
      const [result, wpshead, procData] = await Promise.all([
        getdetailsById(IddetailPK, IddetailSK),
        getbyprojectno(props.rowdata.wld_WPSType, IddetailPK, IddetailSK),
        getActiveProcess()
      ]);

      if (procData?.length > 0) {
        result.forEach(item => {
          const reqProcess = procData.find(element => element.wld_code === item.WPSD_Process);
          if (reqProcess) {
            item.WPSD_WP_WeldingProcess = reqProcess.wld_p_category;
          }
        });
      }

      const processOrder = wpshead[0]?.WPSH_WPS_Process;
      let sortedResult = result;
      if (processOrder) {
        const orderList = processOrder.split(",").filter(Boolean);
        sortedResult = orderList
          .map(process => result.find(item => item.WPSD_Process === process))
          .filter(Boolean);
      }

      setpdf([...wpshead, ...sortedResult]);
    } catch (error) {
      console.error('Error fetching PDF data:', error);
      setLoading(false);
    }
  }, [props.rowdata.wld_WPSType]);

  useEffect(() => {
    fetchbyid(props.rowdata.WPSH_Project_No, props.rowdata.WPSH_WPS_No);
  }, [fetchbyid, props.rowdata.WPSH_Project_No, props.rowdata.WPSH_WPS_No]);

  const fetchAllImages = useCallback(async () => {
    try {
      const { rowdata } = props;
      let imagePaths = [];

      if (rowdata.wld_WPSType === "Tubesheet" && rowdata.Pdf_images) {
        imagePaths = [
          rowdata.Pdf_images[0]?.tube_Hole_ligament[0],
          rowdata.Pdf_images[1]?.tube_Hole[0],
          rowdata.Pdf_images[2]?.tube_Weld_Joint[0]
        ];
      } else if (rowdata.wld_pdf_image) {
        imagePaths = [
          rowdata.wld_pdf_image[0]?.Image1[0],
          rowdata.wld_pdf_image[1]?.Image2[0],
          rowdata.wld_pdf_image[2]?.Image3[0]
        ];
      }

      const urlPromises = imagePaths.map(async (path) => {
        if (path) {
          const result = await getPresignedURL(FOLDERS.WPS, path);
          return result.url;
        }
        return null;
      });

      const [url1, url2, url3] = await Promise.all(urlPromises);
      setPreviewUrls({ url1, url2, url3 });
    } catch (error) {
      console.error('Error fetching images:', error);
    }
  }, [props.rowdata]);


  const fetchSignatures = useCallback(async () => {
    try {
      const { rowdata } = props;
      const signaturePromises = [];

      if (rowdata.wps_signaturePrepared) {
        signaturePromises.push(getPresignedURL(FOLDERS.SIGNATURES, rowdata.wps_signaturePrepared));
      } else {
        signaturePromises.push(Promise.resolve({ url: "" }));
      }

      if (rowdata.wps_signatureApproved) {
        signaturePromises.push(getPresignedURL(FOLDERS.SIGNATURES, rowdata.wps_signatureApproved));
      } else {
        signaturePromises.push(Promise.resolve({ url: "" }));
      }

      const [userResult, approvedResult] = await Promise.all(signaturePromises);
      setSignatures({ user: userResult.url, approved: approvedResult.url });
    } catch (error) {
      console.error('Error fetching signatures:', error);
    }
  }, [props.rowdata.wps_signaturePrepared, props.rowdata.wps_signatureApproved]);

  const downloadPdf = useCallback(() => {
    setTimeout(() => {
      // Create temporary style override for PDF generation
      const style = document.createElement('style');
      document.head.appendChild(style);

      const doc = Jspdf_font(new jsPDF('p', 'pt', "a4"));
      const pdfElement = document.querySelector('#MainDiv');

      doc.html(pdfElement, {
        callback: (doc) => {
          // Remove temporary style
          document.head.removeChild(style);
          const filename = `WPS ${pdf[0].wld_WPSType} - ${pdf[0].WPSH_WPS_No}`;
          doc.save(filename);
          props.onHide();
          props.setReload(!props.reload);
          setLoading(false);
        },
        margin: PDF_MARGIN
      });
    }, PDF_TIMEOUT);
  }, [pdf, props]);


  const pdfContent = useMemo(() => {
    if (pdf.length === 0) return null;

    const isTabesheet = pdf[0]?.wld_WPSType === "Tubesheet";

    return (
      <div id="MainDiv">
        <br />
        {isTabesheet ? (
          <>
            <TubeToTubesheet_pdf_page1
              page="1"
              pdf={pdf}
              previewUrl1={previewUrls.url1}
              previewUrl2={previewUrls.url2}
              previewUrl3={previewUrls.url3}
            />
            <br />
            <Tubesheet_Pdf_Page2
              page="2"
              pdf={pdf}
              Band={props.Band}
              previewuser={signatures.user}
              previewapproved={signatures.approved}
            />
          </>
        ) : (
          <>
            <Groove_pdf_page1 pdf={pdf} />
            <div style={{ pageBreakAfter: "always", paddingTop: "4px" }}>
              <br />
              <Groove_pdf_page2
                pdf={pdf}
                Band={props.Band}
                previewuser={signatures.user}
                previewapproved={signatures.approved}
                previewUrl1={previewUrls.url1}
                previewUrl2={previewUrls.url2}
                previewUrl3={previewUrls.url3}
              />
            </div>
          </>
        )}
      </div>
    );
  }, [pdf, previewUrls, signatures, props.Band]);

  useEffect(() => {
    if (pdf.length > 0) {
      Promise.all([fetchAllImages(), fetchSignatures()]).then(() => {
        downloadPdf();
      });
    }
  }, [pdf, fetchAllImages, fetchSignatures, downloadPdf]);

  return (
    <>
      <Modal
        {...props}
        size="sm"
        centered
        transparent={true}
        className="opacity-100 userMasterModal"
        backdrop="static"
      >
        <Modal.Body
          style={{
            maxHeight: "calc(10vh - 10px)",
          }}
        >
          <p>
            {loading && (
              <BarLoader
                color="blue"
                height={8}
                width={196}
                className="shift"
              />
            )}
          </p>
        </Modal.Body>
      </Modal>
      {pdfContent}
    </>
  );
});

Pdf_Download.displayName = 'Pdf_Download';


export default Pdf_Download;
